import React from 'react';
import PropertyCard from '../components/property/PropertyCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

// Sample property data (in a real app, this would come from an API)
const properties = [
  {
    id: 1,
    title: 'Modern Apartment with Ocean View',
    address: '123 Coastal Drive, Miami, FL',
    price: 450000,
    type: 'For Sale',
    bedrooms: 2,
    bathrooms: 2,
    area: 1200,
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 2,
    title: 'Luxury Villa with Pool',
    address: '456 Palm Avenue, Los Angeles, CA',
    price: 1250000,
    type: 'For Sale',
    bedrooms: 4,
    bathrooms: 3.5,
    area: 3200,
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 3,
    title: 'Downtown Loft',
    address: '789 Urban Street, New York, NY',
    price: 3500,
    type: 'For Rent',
    bedrooms: 1,
    bathrooms: 1,
    area: 950,
    image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 4,
    title: 'Suburban Family Home',
    address: '101 Family Lane, Chicago, IL',
    price: 650000,
    type: 'For Sale',
    bedrooms: 3,
    bathrooms: 2.5,
    area: 2100,
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 5,
    title: 'Beachfront Condo',
    address: '202 Beachside Ave, San Diego, CA',
    price: 4200,
    type: 'For Rent',
    bedrooms: 2,
    bathrooms: 2,
    area: 1100,
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    id: 6,
    title: 'Modern Office Space',
    address: '303 Business Park, Seattle, WA',
    price: 750000,
    type: 'For Sale',
    bedrooms: 0,
    bathrooms: 2,
    area: 1800,
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }
];

const PropertiesPage = () => {
  return (
    <div className="properties-page py-5">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h1>Our Properties</h1>
          <p>Browse our extensive collection of properties</p>
        </div>
        
        <div className="search-container bg-white p-4 rounded shadow mb-5">
          <form className="row g-3">
            <div className="col-md-3">
              <select className="form-select" data-custom-select>
                <option value="">Property Type</option>
                <option value="apartment">Apartment</option>
                <option value="house">House</option>
                <option value="villa">Villa</option>
                <option value="office">Office</option>
              </select>
            </div>
            <div className="col-md-3">
              <select className="form-select" data-custom-select>
                <option value="">Location</option>
                <option value="newyork">New York</option>
                <option value="losangeles">Los Angeles</option>
                <option value="chicago">Chicago</option>
                <option value="miami">Miami</option>
              </select>
            </div>
            <div className="col-md-3">
              <select className="form-select" data-custom-select>
                <option value="">Price Range</option>
                <option value="100-200">$100k - $200k</option>
                <option value="200-500">$200k - $500k</option>
                <option value="500-1000">$500k - $1M</option>
                <option value="1000+">$1M+</option>
              </select>
            </div>
            <div className="col-md-3">
              <button className="btn btn-primary w-100">
                <FontAwesomeIcon icon={faSearch} /> Search
              </button>
            </div>
          </form>
        </div>
        
        <div className="properties-grid">
          <div className="row">
            {properties.map(property => (
              <div className="col-md-4 mb-4" key={property.id}>
                <PropertyCard property={property} />
              </div>
            ))}
          </div>
        </div>
        
        <div className="pagination-container mt-4 d-flex justify-content-center">
          <nav>
            <ul className="pagination">
              <li className="page-item disabled">
                <a className="page-link" href="#" tabIndex="-1">Previous</a>
              </li>
              <li className="page-item active">
                <a className="page-link" href="#">1</a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">2</a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">3</a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default PropertiesPage;
